var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "toast" }, [
    _vm._v(_vm._s(_vm.notification)),
    _c(
      "button",
      {
        staticClass: "toast__close vs-button--no-border py-_5 px-_75",
        attrs: { type: "button" },
        on: { click: _vm.close }
      },
      [_vm._v("X")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }